import React, {useState} from "react";
import {Link} from "react-router-dom";
import Box from "@mui/material/Box";
import "./MyStyles.css";
import {faHouseUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useAuth} from "./context/AuthContext";
import Avatar from "@mui/material/Avatar";
function Header() {
    const [showLanguages, setShowLanguages] = useState(false);
    const {logoutUser} = useAuth();
    const isLoggedIn = localStorage.getItem("user_login") === "true";
    const userRole = localStorage.getItem("userGroup");
    const userName = localStorage.getItem("username");
    // =====================================================
    // CHANGE LANGUAGE
    // =====================================================
    const changeLanguage = (language) => {
        console.log("Changing language:", language);
        // =================================================
        // REMOVE EXISTING GOOGLE TRANSLATE COOKIE
        // =================================================
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        // =================================================
        // ENGLISH
        // =================================================
        if (language === "en") {
            console.log("Switching back to English");
        }

            // =================================================
            // OTHER LANGUAGES
        // =================================================
        else {
            document.cookie = "googtrans=/en/" + language + "; path=/";
            console.log("Google Translate cookie:", "/en/" + language);
        }
        // =================================================
        // CLOSE MENU
        // =================================================
        setShowLanguages(false);
        // =================================================
        // RELOAD PAGE
        //
        // Google Translate reads googtrans cookie
        // during page initialization.
        // =================================================
        window.location.reload();
    };
    // =====================================================
    // LOGOUT
    // =====================================================
    const handleLogout = () => {
        logoutUser();
        window.location.href = "/user-login/";
    };
    // =====================================================
    // UI
    // =====================================================
    return (<nav
        className="navbar navbar-expand-lg navbar-dark custom-navbar"
    >

        <div className="container-fluid">


            {/* =================================================
                    BRAND
                ================================================= */}
            <Avatar
                sx={{
                    width: 52,
                    height: 52,
                    bgcolor: "rgba(255,255,255,.10)",
                    border: "1px solid rgba(244,196,48,.35)",
                    boxShadow: "0 0 30px rgba(244,196,48,.10)",
                    overflow: "hidden",
                }}
            >
                <Box
                    component="img"
                    src="/logo-eagri.png"
                    alt="TN eAGRI AI"
                    sx={{
                        width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%",
                    }}
                />
            </Avatar>
            <Link
                className="navbar-brand ms-3"
                to="/admin-menu"
            >

                TN eAgri AI

            </Link>


            {isLoggedIn && (<>


                {/* =================================================
                            MOBILE MENU BUTTON
                        ================================================= */}

                <button
                    type="button"
                    className="navbar-toggler"
                    data-bs-toggle="collapse"
                    data-bs-target="#menu"
                    aria-controls="menu"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >

                            <span
                                className="navbar-toggler-icon"
                            />

                </button>


                {/* =================================================
                            LANGUAGE AREA
                        ================================================= */}

                <div className="gt-navbar-wrapper">


                    {/* =================================================
                                LANGUAGE BUTTON
                            ================================================= */}

                    <button
                        type="button"
                        className="gt-language-btn"
                        title="Translate"
                        aria-label="Translate"
                        onClick={() => setShowLanguages(prev => !prev)}
                    >

                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                        >

                            <circle
                                cx="12"
                                cy="12"
                                r="9"
                                stroke="currentColor"
                                strokeWidth="2"
                            />

                            <path
                                d="M3 12H21"
                                stroke="currentColor"
                                strokeWidth="2"
                            />

                            <path
                                d="M12 3C14.5 5.5 15.5 8.5 15.5 12C15.5 15.5 14.5 18.5 12 21"
                                stroke="currentColor"
                                strokeWidth="2"
                            />

                            <path
                                d="M12 3C9.5 5.5 8.5 8.5 8.5 12C8.5 15.5 9.5 18.5 12 21"
                                stroke="currentColor"
                                strokeWidth="2"
                            />

                        </svg>

                    </button>


                    {/* =================================================
                                LANGUAGE MENU
                            ================================================= */}

                    {showLanguages && (<div className="gt-language-menu">


                        <button
                            type="button"
                            onClick={() => changeLanguage("en")}
                        >
                            English
                        </button>


                        <button
                            type="button"
                            onClick={() => changeLanguage("ta")}
                        >
                            தமிழ்
                        </button>


                        <button
                            type="button"
                            onClick={() => changeLanguage("te")}
                        >
                            తెలుగు
                        </button>


                        <button
                            type="button"
                            onClick={() => changeLanguage("hi")}
                        >
                            हिन्दी
                        </button>


                        <button
                            type="button"
                            onClick={() => changeLanguage("ml")}
                        >
                            മലയാളം
                        </button>


                        <button
                            type="button"
                            onClick={() => changeLanguage("kn")}
                        >
                            ಕನ್ನಡ
                        </button>


                    </div>)}


                </div>


                {/* =================================================
                            NAVIGATION
                        ================================================= */}

                <div
                    id="menu"
                    className="collapse navbar-collapse"
                >


                    {/* =================================================
                                LEFT MENU
                            ================================================= */}

                    <ul
                        className="navbar-nav me-auto"
                    >

                        <li className="nav-item">

                            <Link
                                to="/admin-menu"
                                className="nav-link"
                            >

                                <FontAwesomeIcon
                                    icon={faHouseUser}
                                    size="lg"
                                    style={{
                                        color: "#ffc107"
                                    }}
                                />

                                {" "}MENU

                            </Link>

                        </li>

                    </ul>


                    {/* =================================================
                                RIGHT MENU
                            ================================================= */}

                    <ul
                        className="navbar-nav ms-auto align-items-center"
                    >

                        <li
                            className="nav-item dropdown"
                        >


                            {/* =================================================
                                        USER DROPDOWN BUTTON

                                        Changed from <a href="#">
                                        to <button> to remove
                                        jsx-a11y warning.
                                    ================================================= */}

                            <button
                                type="button"
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >

                                {userName}

                            </button>


                            <ul
                                className="dropdown-menu dropdown-menu-end"
                            >


                                <li>

                                            <span
                                                className="dropdown-item-text"
                                            >

                                                Role : {userRole}

                                            </span>

                                </li>


                                <li>

                                    <hr
                                        className="dropdown-divider"
                                    />

                                </li>


                                <li>

                                    <Link
                                        className="dropdown-item"
                                        to="/change-password"
                                    >
                                        Change Password
                                    </Link>

                                </li>


                                <li>

                                    <button
                                        type="button"
                                        onClick={handleLogout}
                                        className="dropdown-item text-danger"
                                    >

                                        Logout

                                    </button>

                                </li>


                            </ul>

                        </li>

                    </ul>


                </div>

            </>)}

        </div>

    </nav>);
}
export default Header;